import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from '@emailjs/browser';

const FormFeedbackFr = () => {
    const [name, setName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [issueType, setIssueType] = useState('- Select -');
    const [otherIssue, setOtherIssue] = useState('');
    const [subject, setSubject] = useState('');
    const [feedback, setFeedback] = useState('');
    const [messageSent, setMessageSent] = useState();
    const [messageError, setMessageError] = useState();
    const [captchaValue, setCaptchaValue] = useState(null);
    const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
        
    const renderTextField = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.name}>{inputData.label}</label>
                <div className='input_container input_container_text'>
                    <input name={inputData.name}
                        id={inputData.name}
                        type={inputData.type}
                        value={value}
                        className='medium'
                        aria-invalid="false"
                        aria-required={inputData.ariaRequired}
                        aria-describedby={inputData.description}
                        onChange={(e) => onChange(e.target.value)}>
                    </input>
                    {inputData.message ? <span id={inputData.description}>{inputData.message}</span> : ""}
                </div>
            </>
        );
    }

    const renderTextArea = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.name}>{inputData.label}<span className='field_required'>*</span></label>
                <div className='input_container input_container_textarea'>
                    <textarea name={inputData.name}
                        id={inputData.name}
                        className='textarea medium'
                        value={value}
                        aria-invalid="false" rows='10' cols='50'
                        aria-describedby={inputData.description}
                        onChange={(e) => onChange(e.target.value)} />
                    {inputData.message ? <span id={inputData.description}>{inputData.message}</span> : ""}
                </div>
            </>
        );
    }

    const renderEmailField = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.name}>{inputData.label}</label>
            <div className='input_container input_container_email'>
                <input 
                name={inputData.name} 
                id={inputData.name} 
                type='email' 
                value={value} 
                className='medium' 
                aria-required="false" aria-invalid="false" aria-describedby={inputData.description}
                onChange={(e) => onChange(e.target.value)}>
                </input>
                {inputData.message ? <span id={inputData.description}>{inputData.message}</span> : ""}
            </div>
            </>
        );
    }

    const renderDropdown = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}<span className='field_required'>*</span></label>
                <div className='input_container input_container_select'>
                    <select 
                        name={inputData.name} 
                        id={inputData.id} 
                        className='medium field_select' 
                        aria-required="true" 
                        aria-invalid="false"
                        aria-describedby={inputData.description}
                        value={ value }
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {inputData.option.map(({value, label}, i) => <option key={`${inputData.name}-${i}`} value={value}>{label}</option>)}
                    </select>
                    {inputData.message ? <span id={inputData.description}>{inputData.message}</span> : ""}
                </div>
            </>
        )
    }

    const renderName = () => {
        const inputData = {
            name: 'name',
            id: 'nom',
            label: 'Nom (facultatif)',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_name',
            message: 'Si vous souhaitez fournir de la rétroaction à titre anonyme, laissez le champ de noms vide.'
        }
        return renderTextField(inputData, name, setName);
    }

    const renderEmailDetails = () => {
        const inputData = {
            name: 'email',
            label: 'Courriel (facultatif)',
            type: 'email',
            description: 'field_description_email',
            message: 'Si vous souhaitez fournir de la rétroaction à titre anonyme, veuillez laisser le champ d\'adresse courriel vide.',
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress);
    }

    const renderPhone = () => {
        const inputData = {
            name: 'phone',
            label: 'Numéro de téléphone (facultatif)',
            type: 'text',
            value: '',
            ariaRequired: 'false',
            description: 'field_description_phone',
            message: 'Si vous souhaitez fournir de la rétroaction à titre anonyme, laissez le champ de numéro de téléphone vide.'
        }
        return renderTextField(inputData, phone, setPhone);
    }

    const renderIssueType = () => {
        const inputData = {
            name: 'issue-type',
            id: 'issue-type',
            label: 'Type de problème',
            option: [
                {label: '- Choisissez un problème -', value: '- Choisissez un problème -'},
                {label: 'Accessibilité du contenu', value: 'Accessibilité du contenu'},
                {label: 'Accessibilité numérique (site web/application)', value: 'Accessibilité numérique (site web/application)'},
                {label: 'Emploi', value: 'Emploi'},
                {label: 'Installations de CPAC', value: 'Installations de CPAC'},
                {label: 'Demande de format différent', value: 'Demande de format différent'},
                {label: 'Autre (veuillez préciser)', value: 'Autre'},
            ],
            description: 'field_description_issue',
            message: 'Veuillez choisir l\'option qui correspond le mieux à votre problème.'
        };

        return renderDropdown(inputData, issueType, setIssueType);
    }

    const renderOtherIssue = () => {
        const inputData = {
            name: 'other-issue',
            id: 'otherIssue',
            label: 'Type de problème - Autre',
            type: 'text',
            value: '',
            required: '',
            ariaRequired: 'false',
            description: 'field_description_other_issue',
        }
        return renderTextField(inputData, otherIssue, setOtherIssue);
    }

    const renderSubject = () => {
        const inputData = {
            name: 'subject',
            label: 'Objet',
            type: 'text',
            value: '',
            ariaRequired: 'false',
            description: 'field_description_subject',
            message: 'Veuillez résumer votre problème en moins de 60 caractères.'
        }
        return renderTextField(inputData, subject, setSubject);
    }

    const renderFeedback = () => {
        const inputData = {
            name: 'feedback',
            label: 'Commentaires',
            description: 'field_description_feedback',
            message: 'Veuillez décrire votre problème, en précisant les détails pertinents tels que la page web ou l\'émission concernée. Les commentaires peuvent être d\'ordre général.'
        }
        return renderTextArea(inputData, feedback, setFeedback);
    }
    const captchaRef = useRef(null);
    
    const onReCaptchaChange = (value) => {
        setCaptchaValue(value);
    }

    const buttonDisabled = (captchaValue) => {
        return (
            !captchaValue ? "disabled" : ""
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        captchaRef.current.reset();

        const templateParams = {
            senderLanguage: "Français",
            senderName: name ? name : "anonyme",
            senderEmail: emailAddress ? emailAddress : "l'adresse courriel n'a pas été fournie", 
            senderPhone: phone ? phone : "le numéro de téléphone n'a pas été fourni",
            senderIssueType: issueType === "Autre" ? otherIssue : issueType !== "Autre" ? issueType : "un problème n'a pas été fourni",
            senderSubject: subject ? subject : "aucun sujet n'a été fourni", 
            senderComments: feedback
        };
        emailjs.send('outlook_service', 'feedback_template', templateParams, process.env.REACT_APP_EMAILJS_KEY)
                    .then(function() {
                        setMessageSent(true);
                        e.target.reset(); // reset the form
                    }, function(error) {
                        setMessageError(true);
                    });
    }
    
    return (
        <>
        {
            messageSent ? <h2 className='form_wrapper message_success'>Nous vous remercions de votre commentaire.</h2> : messageError ? <h2 className='form_wrapper message_fail'>Désolé, il y a eu un problème avec votre envoi. Prière de réessayer plus tard.</h2> : 
            <div id="form_wrapper" className="form_wrapper">
                <form id="contact-form" onSubmit={(e) => handleSubmit(e)} itemScope itemType="https://schema.org/WebPageElement">
                    <div className="form_body" itemProp='mainEntityOfPage'>
                        {renderName()}
                        {renderEmailDetails()}
                        {renderPhone()}
                        {renderIssueType()}
                        { issueType === 'Autre' ? renderOtherIssue() : '' }
                        {renderSubject()}
                        {renderFeedback()}
                    </div>
                    <div className='recaptcha'>
                        <ReCAPTCHA sitekey={captchaKey} ref={captchaRef} onChange={onReCaptchaChange} hl="fr" />
                    </div>
                    <div className='form_footer left_label'>
                        <button type="submit" name='submit' value='soumettre' className="btn--primary" disabled={buttonDisabled(captchaValue)}>Soumettre</button>
                    </div>
                </form>
            </div>
        }
        </>
    )
}

export default FormFeedbackFr;